<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: user.slug }}"
    :showCloseButton="true"
  >
    <div v-if="!confirmRemove">
      <span
        slot="heading"
        class="p-3"
      >
        Manage add-ons
      </span>
      <span
        slot="description"
        class="p-3"
      >Add and remove add-ons and options used in your menu</span>
    </div>
    <div
      slot="content"
      class="p-3"
    >
      <form
        class="mt-3"
        v-on:submit.prevent="onSubmit"
        v-if="!confirmRemove"
      >

        <div class="form-group p-3 bg-light rounded border shadow-sm">
          <input
            placeholder="Add-on label e.g add Bacon"
            v-model="optionLabel"
            type="text"
            maxlength="128"
            class="form-control form-control-sm mb-2 animate__animated animate__fadeIn"
          />

          <input
            placeholder="Add-on price"
            v-model="optionPrice"
            type="number"
            step="0.01"
            class="form-control form-control-sm mb-2"
          />

          <a
            v-if="optionLabel && optionPrice"
            href="#"
            class="d-inline-block color-1 small font-weight-bold animate__animated animate__fadeIn"
            v-on:click.prevent="addOption()"
          >
            Add Option
          </a>
        </div>
        <div class="form-group">
          <draggable v-model="options">
            <div
              v-for="(option,index) in options"
              :key="index"
            >
              <div
                class="py-3 px-1 border-bottom bg-white"
                v-if="option.removeItem===false"
              >
                <div class="d-flex justify-content-between">
                  <div>
                    <span class="text-muted">{{ option.label }}</span> <span class="font-weight-bold">{{ rawMenu.user.currency.symbol }}{{ option.amount | centsToDollars}}</span>
                  </div>

                  <div class="text-right">
                    <a
                      href=""
                      class="ml-3 small color-1"
                      v-on:click.prevent="confirmRemoveOption(option)"
                    >Remove</a>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
        </div>
        <div class="mt-4">

          <formSubmit
            v-if="(!processing&&!updated)"
            class="animate__animated animate__fadeIn"
          />

          <div
            class="text-center font-weight-bold color-1 animate__animated animate__fadeIn"
            v-if="updated"
          >Updated</div>
        </div>
      </form>
      <div
        class="mt-3 animated fadeIn"
        v-if="confirmRemove"
      >
        <strong>{{ optionToRemove.label }}</strong> is in use, for example it is used in the add-on group <strong>{{ rmOGname }}</strong> which is in the menu item <strong>{{ rmITname }}</strong>. If you remove this add-on, the add-on groups that contain this add on will be removed too .
        <div class="mt-4">
          <button
            v-on:click="removeOption(optionToRemove)"
            class="btn btn-primary btn-sm"
          >
            Remove
          </button>
          <button
            class="btn btn-secondary btn-sm"
            v-on:click="cancelRemoveOption()"
          >
            Cancel
          </button>
        </div>
      </div>

      <div
        v-if="processing"
        class="text-center my-5"
      >
        <formLoader
          v-if="processing"
          class="mb-2"
          :width="30"
        ></formLoader>
      </div>
    </div>
  </modal>
</template>

  <style scoped>
</style>

  <script>
import accountingMixin from "../../../mixins/accountingMixin";
import formLoader from "../../form/FormLoader";
import formSubmit from "../../form/FormSubmit";
import modal from "../../shared/Modal";
import draggable from "vuedraggable";
import { ToggleButton } from "vue-js-toggle-button";
export default {
  mounted() {
    this.options = _.cloneDeep(this.rawMenu.item_options);
    _.forEach(this.options, function (cValue, cKey) {
      cValue.removeItem = false;
    });
  },
  data() {
    return {
      options: [],
      processing: false,
      updated: false,
      uploadPercentage: 0,
      optionPrice: null,
      optionLabel: null,
      optionToRemove: null,
      confirmRemove: false,
      rmOGname: null,
      rmITname: null,
    };
  },
  methods: {
    onSubmit: function () {
      this.processing = true;
      let formData = new FormData();
      formData.append("options", JSON.stringify(this.options));
      formData.append("_method", "PATCH");
      axios
        .post(this.itemOptionsUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this),
        })
        .then(
          (response) => {
            this.error = null;
            if (response.data) {
              this.refreshMenu(this.$route.params.userSlug);
            }
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },
    addOption: function () {
      if (this.optionLabel && this.optionPrice) {
        this.options.push({
          amount: parseFloat(this.optionPrice) * 100,
          label: this.optionLabel,
          id: null,
          removeItem: false,
        });
        this.optionPrice = null;
        this.optionLabel = "";
      }
    },
    cancelRemoveOption: function () {
      this.optionToRemove = null;
      this.confirmRemove = false;
      this.rmOGname = null;
      this.rmITname = null;
    },
    confirmRemoveOption: function (option) {
      let _self = this;
      let canFindOption = false;
      _.forEach(this.rawMenu.categories, function (cValue, cKey) {
        _.forEach(cValue.items, function (iValue, iKey) {
          _.forEach(iValue.option_groups, function (ogValue, ogKey) {
            _.forEach(ogValue.options, function (o, ogKey) {
              if (o.id === option.id) {
                _self.optionToRemove = option;
                _self.confirmRemove = true;
                _self.rmOGname = ogValue.label;
                _self.rmITname = iValue.name;
                canFindOption = true;
              }
            });
          });
        });
      });

      if (canFindOption) {
        return;
      } else {
        this.removeOption(option);
      }
    },
    removeOption: function (option) {
      let obj = _.find(this.options, function (o) {
        return o.id === option.id;
      });
      if (obj) {
        obj.removeItem = true;
      }
      this.options = _.cloneDeep(this.options);
      this.optionToremove = null;
      this.confirmRemove = false;
      this.confirmRemoveMessage = null;
    },
  },
  watch: {
    // On update
    rawMenu(newValue, oldValue) {
      this.options = _.cloneDeep(this.rawMenu.item_options);
      _.forEach(this.options, function (cValue, cKey) {
        cValue.removeItem = false;
      });
      this.processing = false;
      this.updated = true;
      setTimeout(() => {
        this.updated = false;
      }, "1000");
    },
  },
  components: {
    draggable,
    formLoader,
    formSubmit,
    modal,
    ToggleButton,
  },
  mixins: [accountingMixin],
  computed: {
    itemOptionsUrl: function () {
      return "/api/" + this.$route.params.userSlug + "/menu/options";
    },
  },
};
</script>
